import { InfoMessageModel } from "../infoMessage/InfoMessageModel"

/** Resolves parent-owned and local messages without mutating either source. */
export class CardScreenMessageController {
  private externalActionError?: InfoMessageModel
  private persistentAlert?: InfoMessageModel
  private localMessage?: InfoMessageModel

  constructor(private readonly onMessageChange: (message?: InfoMessageModel) => void) {}

  setExternalMessage(message?: InfoMessageModel) {
    if (message?.infoType === "ALERT") {
      this.persistentAlert = message
      this.externalActionError = undefined
    } else if (message?.infoType === "ERROR") {
      this.externalActionError = message
    } else {
      this.externalActionError = undefined
      this.persistentAlert = undefined
    }
    if (!this.localMessage) {
      this.onMessageChange(this.externalActionError || this.persistentAlert)
    }
  }

  beginAttempt() {
    this.clearActionError()
  }

  clearActionError() {
    this.localMessage = undefined
    this.externalActionError = undefined
    this.onMessageChange(this.persistentAlert)
  }

  showLocalError(message: string) {
    this.localMessage = { infoType: "ERROR", infoMessage: message }
    this.onMessageChange(this.localMessage)
  }
}
